module.exports = __webpack_public_path__ + "img/cloud_bottom_mobile.953febff.png";